import React, {useEffect} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {useHistory} from 'react-router-dom';

import {DETAILS_PAGE_URL, UPDATE_PAGE_URL, NON_EDITABLE_STATUS} from '../../../constants';

import OtpVerifyUI from '../../../stories/components/Onboarding/OtpVerify/OtpVerifyUI';
import {sendEvarData} from '@ibibo/analytics';

import * as actions from '../../../store/actions/index';
import {
  statusSelector,
  emailSelector,
  errorSelector,
  tokenSelector,
  mobileWithCodeSelector,
  nextLoader,
  mobileCount,
  emailCount,
} from '../../../store/selectors';
import {setter, removeItem} from '../../../../../../common/client-side-storage/src/client-side-storage.web';

const OtpVerify = () => {
  const history = useHistory();

  const token = useSelector(tokenSelector);
  const status = useSelector(statusSelector);
  const email = useSelector(emailSelector);
  const mobile = useSelector(mobileWithCodeSelector);
  const error = useSelector(errorSelector);
  const setLoader = useSelector(nextLoader);
  const mobile_count = useSelector(mobileCount);
  const email_count = useSelector(emailCount);

  const dispatch = useDispatch();

  const editField = () => {
    history.goBack();
  };

  const resendOTP = type => {
    let fd = new FormData();
    fd.append('token', token);
    if (type === 'motp') {

        fd.append('resend', 'mobile');
        sendEvarData({
            prop54: "myPartner|signup|OTPVerification|resendOTP|mobile"
          }, true)
    }
    if (type === 'eotp') {
        fd.append('resend', 'email');
        sendEvarData({
            prop54: "myPartner|signup|OTPVerification|resendOTP|email"
          }, true)
    }
    dispatch(actions.resendOTP(fd, type));
  };

  useEffect(() => {
    setter("token", `${token}`);
  }, [])

  const successCallback = statusStr => {
    dispatch(actions.submitKYCModalInfo(''))
    if (NON_EDITABLE_STATUS.indexOf(statusStr) !== -1) {
      history.push(`${UPDATE_PAGE_URL}`);
    } else {
      history.push(`${DETAILS_PAGE_URL}`);
    }
  };

  const submit = data => {
    if (NON_EDITABLE_STATUS.indexOf(status) !== -1) {
      successCallback(status);
      return;
    }
    let fd = new FormData();
    fd.append('mobile_otp', data.mobile_otp);
    fd.append('email_otp', data.email_otp);
    fd.append('token', token);
    dispatch(actions.verifyOTP(fd, successCallback));

  };

  return (
    <OtpVerifyUI
      onOTPSubmit={submit}
      editField={editField}
      resendOTP={resendOTP}
      email={email}
      mobile={mobile}
      apiError={error}
      setLoader={setLoader}
      status={status}
      mobile_count={mobile_count}
      email_count={email_count}
    />
  );
};

export default OtpVerify;
